module.exports = __webpack_public_path__ + "static/media/18ECA18.12cea5ae.jpg";